__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "employees-shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular-architects/module-federation-tools", "20.0.0", () => (__webpack_require__.e(388).then(() => (() => (__webpack_require__(3007))))));
			register("@angular/common/http", "20.3.16", () => (__webpack_require__.e(396).then(() => (() => (__webpack_require__(8015))))));
			register("@angular/common", "20.3.16", () => (__webpack_require__.e(229).then(() => (() => (__webpack_require__(7610))))));
			register("@angular/core/primitives/di", "20.3.16", () => (__webpack_require__.e(248).then(() => (() => (__webpack_require__(2867))))));
			register("@angular/core/primitives/signals", "20.3.16", () => (__webpack_require__.e(70).then(() => (() => (__webpack_require__(5689))))));
			register("@angular/core", "20.3.16", () => (__webpack_require__.e(17).then(() => (() => (__webpack_require__(7017))))));
			register("@angular/platform-browser", "20.3.16", () => (__webpack_require__.e(276).then(() => (() => (__webpack_require__(7276))))));
			register("@angular/router", "20.3.16", () => (__webpack_require__.e(39).then(() => (() => (__webpack_require__(6039))))));
			register("@avaldigitallabs/adl-commons-lib-frontend-event-bus", "1.2.1", () => (__webpack_require__.e(434).then(() => (() => (__webpack_require__(7434))))));
			register("@avaldigitallabs/adl-commons-lib-secure-web-storage", "0.1.4", () => (__webpack_require__.e(882).then(() => (() => (__webpack_require__(9882))))));
			register("rxjs/operators", "7.8.0", () => (__webpack_require__.e(620).then(() => (() => (__webpack_require__(3620))))));
			register("rxjs", "7.8.0", () => (__webpack_require__.e(340).then(() => (() => (__webpack_require__(1340))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};